module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.payload) ? _c('div', {
    staticClass: "comments"
  }, [(!_vm.commenters || _vm.commenters.length <= 0) ? _c('span', {
    staticClass: "tooltip"
  }, [_c('span', {
    staticClass: "tooltiptext"
  }, [_vm._v("comments")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.commenters), function(commenter) {
    return _c('team-member-avatar', {
      key: _vm.comment.id,
      attrs: {
        "subject": commenter,
        "height": "50px",
        "width": "50px"
      }
    })
  }), _vm._v(" "), _c('router-link', {
    staticClass: "button show-comments",
    attrs: {
      "to": '/a/document/' + _vm.payload.id + '/comments'
    }
  }, [_c('span', [_c('i', {
    staticClass: "icon icon-chat"
  })])])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74340599","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/partials/comments-float.vue
// module id = 536
// module chunks = 0